<template>
  <div class="mb-3">
    <button class="btn btn-success" @click="$emit('open-modal')">
      + {{ $t('add_project_payment') }}
    </button>
  </div>
</template>

<script>
export default {
  name: 'ProjectPaymentActionButton'
}
</script>

